export const URL = "https://www.porlor.co.th/porlor-api/"; // for production
export const URLTEST = "https://www.porlor.co.th/porlor-api/"; // for server test
export const urlLocal = "https://www.porlor.co.th/porlor-api/"; //for local test

//export const URL = "http://localhost/porlor/"; // for production
//export const URLTEST = "http://localhost/porlor/"; // for server test
//export const urlLocal = "http://localhost/porlor/"; //for local test
